<template>
  <export-email-report-dialog
    title="Enviar relatório do sorteio"
    description="O relatório de participantes de um sorteio é enviado, através de um e-mail, para a caixa de entrada dos endereços de e-mail adicionados abaixo. Um arquivo CSV contendo todas as informações detalhadas de cada participante do sorteio é enviado em anexo ao e-mail."
    async
    :buttonText="buttonText"
    :exportReportFn="exportReport"
    :disabled="disabled"
    disableXLSX
    @file-format="getFileFormat"
  />
</template>

<script>
import { SEND_RAFFLE_PARTICIPANTS_LIST_EMAIL } from '../../graphql'

import ExportEmailReportDialog from '@/components/export-email-report/ExportEmailReportDialog.vue'
export default {
  name: 'ExportRaffleParticipantsDialog',
  components: {
    ExportEmailReportDialog,
  },
  props: {
    buttonText: {
      type: String,
      default: '',
    },
    raffleId: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    secap: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    fileFormat: 'CSV',
  }),
  methods: {
    getFileFormat(value) {
      this.fileFormat = value
    },
    async exportReport(emails) {
      return this.$apollo.mutate({
        mutation: SEND_RAFFLE_PARTICIPANTS_LIST_EMAIL,
        fetchPolicy: 'no-cache',
        variables: {
          raffleId: this.raffleId,
          fileFormat: this.fileFormat,
          emails,
          secapMode: this.secap,
        },
        context: {
          uri: this.$microservicesUrls['asyncJobs'],
        },
      })
    },
  },
}
</script>
